import React from 'react';
import {socialNetworkLinks} from '../social-network-link/social-network-link.utils';
import {SocialNetworkLink} from '../social-network-link/social-network-link.component';
import './social-network-wrapper.scss';

export const SocialNetworkWrapper = () => {
    return (
        <div className='social-network-wrapper'>
            <ul>
                {socialNetworkLinks.map((rrss, i) => (
                    <li key={`${rrss.title}-${i}`}>
                        <SocialNetworkLink link={rrss.link} title={rrss.title} icon={rrss.icon}/>
                    </li>
                ))}
            </ul>
        </div>
    );
};
